package app.svg

import dev.fritz2.core.RenderContext

fun RenderContext.logo(className: String) {
    svg(className) {
        attr("xmlns", "http://www.w3.org/2000/svg")
        attr("viewBox", "0 0 2000 429")
        attr("fill", "currentColor")
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr("d", "M4070 2145 l0 -2085 45 0 45 0 0 2085 0 2085 -45 0 -45 0 0 -2085z")
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M2957 3781 c-73 -11 -185 -65 -259 -128 -32 -26 -111 -98 -176 -159 l-118 -111 -73 -7 c-40 -3 -279 -36 -529 -71 -443 -63 -458 -66 -535 -102 -102 -48 -141 -91 -134 -145 3 -22 14 -49 24 -60 10 -11 116 -97 236 -191 120 -94 216 -173 215 -177 -2 -4 -55 -55 -118 -114 -63 -59 -121 -119 -129 -133 -8 -15 -11 -42 -8 -63 l5 -38 -192 -67 c-105 -37 -199 -72 -208 -76 -24 -13 -36 -66 -26 -112 22 -98 127 -256 267 -401 196 -202 334 -275 395 -208 8 10 48 110 88 222 l73 205 40 1 c22 0 47 4 56 10 9 5 79 69 155 142 l138 132 386 -385 c413 -413 415 -414 479 -381 31 17 122 130 156 196 36 69 3 344 -124 1045 l-59 320 102 105 c162 168 429 459 454 495 57 81 35 168 -52 209 -78 38 -395 65 -529 47z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M2975 3658 c-31 -16 -95 -81 -95 -94 0 -16 70 -74 90 -74 21 0 160 141 160 163 0 14 -10 17 -67 17 -38 0 -77 -6 -88 -12z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M1087 1956 c-18 -48 150 -269 277 -364 30 -23 71 -29 81 -12 35 56 -248 390 -330 390 -13 0 -25 -6 -28 -14z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M5106 3119 c-43 -5 -81 -10 -83 -13 -2 -2 3 -55 12 -117 14 -100 16 -200 12 -794 -3 -374 -8 -697 -12 -717 l-7 -38 505 0 505 0 6 58 c4 31 10 72 13 90 l5 32 -403 0 -404 0 3 755 4 755 -39 -1 c-21 -1 -73 -5 -117 -10z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M6941 3119 c-35 -4 -67 -13 -71 -19 -4 -7 -15 -56 -24 -111 -13 -81 -65 -233 -280 -824 l-263 -725 102 0 103 0 67 183 c37 100 79 212 92 250 l25 67 298 0 298 0 84 -250 83 -250 109 0 c101 0 108 1 103 19 -2 10 -138 390 -302 845 l-298 826 -31 -1 c-17 -1 -60 -5 -95 -10z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M7976 3119 c-43 -5 -81 -10 -83 -13 -3 -2 1 -35 8 -73 8 -45 15 -250 19 -603 8 -566 10 -590 60 -721 47 -124 155 -229 273 -264 82 -25 200 -30 294 -12 244 46 373 203 403 488 5 57 10 340 10 645 l0 544 -110 0 -110 0 0 -612 c0 -649 -1 -662 -48 -755 -45 -88 -160 -141 -280 -131 -129 12 -211 93 -259 255 -15 51 -17 130 -21 661 l-3 602 -37 -1 c-20 -1 -72 -5 -116 -10z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M9401 3119 c-41 -5 -76 -11 -78 -13 -3 -2 3 -52 11 -110 13 -90 16 -223 16 -831 l0 -725 100 0 100 0 0 523 0 522 -35 230 c-19 126 -32 231 -31 233 4 3 24 -47 138 -344 24 -61 167 -348 318 -638 l274 -526 93 0 93 0 0 846 0 846 -67 -6 c-38 -4 -83 -10 -100 -13 l-33 -5 0 -518 0 -518 40 -222 c22 -123 39 -227 38 -232 -2 -6 -44 91 -93 214 -70 176 -146 335 -364 760 l-276 537 -35 -1 c-19 0 -68 -4 -109 -9z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M11315 3115 c-328 -61 -544 -321 -587 -705 -41 -373 125 -738 412 -903 200 -115 507 -111 688 8 28 20 52 40 52 45 0 8 -61 111 -76 129 -2 2 -36 -11 -75 -29 -94 -43 -194 -58 -295 -43 -170 24 -305 133 -392 314 -71 147 -86 215 -86 379 0 152 19 242 77 360 38 77 129 173 203 212 141 76 358 76 497 0 l50 -27 48 55 c27 30 49 58 49 62 0 12 -97 78 -153 103 -114 53 -266 67 -412 40z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M12326 3119 c-43 -5 -81 -11 -84 -14 -3 -3 2 -63 11 -133 15 -110 17 -222 17 -829 l0 -703 105 0 105 0 0 405 0 405 315 0 315 0 0 -405 0 -405 105 0 105 0 0 846 0 847 -62 -7 c-35 -4 -82 -9 -105 -12 l-43 -6 0 -339 0 -339 -315 0 -315 0 0 350 0 350 -37 -1 c-21 -1 -73 -5 -117 -10z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M18550 3116 c-368 -80 -590 -389 -590 -821 0 -290 122 -565 319 -722 66 -52 194 -115 271 -134 76 -19 269 -17 347 4 65 17 160 62 202 95 l24 19 -37 61 c-20 34 -41 64 -45 67 -5 2 -37 -8 -72 -24 -111 -50 -221 -63 -331 -40 -146 31 -284 150 -362 311 -68 142 -81 198 -81 373 0 113 5 166 18 215 72 266 257 420 504 420 93 0 164 -15 237 -51 32 -16 62 -29 66 -29 4 0 28 25 54 56 l46 56 -28 23 c-54 45 -128 86 -192 106 -85 27 -260 34 -350 15z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M15231 3109 c-41 -5 -76 -11 -79 -13 -2 -3 3 -47 12 -99 14 -81 16 -200 16 -826 l0 -731 105 0 105 0 0 340 0 340 69 0 70 0 229 -337 228 -338 122 -3 c67 -1 122 1 122 5 -1 4 -99 152 -219 328 l-218 320 -77 25 -77 25 73 19 c247 61 399 213 428 427 36 257 -122 448 -420 509 -103 21 -344 26 -489 9z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M13650 3020 l0 -90 235 0 235 0 0 -745 0 -745 105 0 105 0 0 745 0 745 235 0 235 0 0 90 0 90 -575 0 -575 0 0 -90z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M16617 3068 c-4 -24 -9 -64 -13 -90 l-6 -48 211 0 211 0 0 -655 0 -655 -200 0 -200 0 0 -90 0 -90 499 0 c275 0 502 3 505 8 2 4 7 44 11 90 l8 82 -207 0 -206 0 0 655 0 655 195 0 195 0 0 90 0 90 -499 0 -499 0 -5 -42z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M700 2687 c-130 -44 -227 -128 -282 -243 -76 -161 -49 -316 77 -452 l57 -62 -46 -50 c-50 -54 -53 -61 -31 -80 13 -11 25 -3 77 49 70 70 156 116 248 133 53 10 60 14 60 35 0 20 -5 23 -34 23 -42 0 -151 -33 -193 -59 l-32 -20 -56 57 c-30 31 -68 81 -83 111 -23 48 -27 69 -27 141 0 76 4 93 33 152 132 268 509 320 715 99 41 -44 51 -50 67 -41 11 6 20 15 20 21 0 20 -116 127 -166 152 -123 62 -282 76 -404 34z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M607 1796 c-159 -52 -291 -97 -295 -100 -3 -4 -1 -11 5 -17 8 -8 91 14 302 82 238 76 291 96 291 111 0 10 -3 18 -7 18 -5 -1 -138 -43 -296 -94z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M1897 1743 c-4 -3 -7 -16 -7 -28 0 -19 7 -23 46 -29 62 -8 158 -61 201 -110 78 -90 114 -225 94 -350 -28 -169 -116 -279 -268 -336 -202 -76 -406 -21 -513 137 -13 19 -18 21 -38 10 l-22 -13 31 -48 c176 -265 662 -216 813 82 72 143 74 328 5 464 -25 50 -102 133 -149 163 -64 40 -177 74 -193 58z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M805 1570 c-192 -104 -258 -150 -214 -150 11 0 351 177 426 222 20 12 30 24 26 34 -3 7 -8 14 -12 13 -3 0 -105 -54 -226 -119z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M380 1550 c0 -129 57 -257 160 -360 154 -154 365 -192 564 -101 67 31 80 44 67 69 -11 20 -11 20 -70 -9 -88 -44 -189 -62 -270 -50 -219 34 -401 244 -401 462 0 42 -3 47 -25 51 -25 5 -25 4 -25 -62z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M1022 1359 c-98 -122 -120 -154 -111 -165 7 -8 13 -13 14 -12 61 68 245 304 242 311 -9 27 -30 7 -145 -134z"
            )
        }
        path {
            attr("transform", "translate(0.000000,429.000000) scale(0.100000,-0.100000)")
            attr(
                "d",
                "M1316 1348 c-85 -298 -126 -472 -114 -479 7 -5 16 -5 19 -1 7 8 139 502 139 520 0 6 -6 12 -14 12 -9 0 -21 -21 -30 -52z"
            )
        }
    }
}